import * as yup from 'yup';

export const addNotesSchema = yup.object().shape({
  title: yup.string().required('Title is required'),
  content: yup.string().required('Description is required'),
  isPrivate: yup.object().shape({
    label: yup.string().required('Visibility is required'),
    value: yup.boolean().required('Visibility is required'),
  }).required('Visibility is required'),
});